import { Bundle, BundleAssets } from './bundle.js';

import type { IBundleManifest, IImageManifest } from '../../../shared/manifest/index.js';
import type { AssetsStorage } from '../assets/AssetsStorage.js';

/**
 * Загрузчик бандлов
 */
export class BundleLoader {
  private readonly assetsStorage: AssetsStorage;
  private readonly _bundles: Map<string, Bundle> = new Map();

  public constructor(assetsStorage: AssetsStorage) {
    this.assetsStorage = assetsStorage;
  }

  public createBundle(name: string, manifest: IBundleManifest, assets: IImageManifest['assets']) {
    if (this._bundles.has(name)) {
      return this._bundles.get(name) as Bundle;
    }

    const bundleAssets = new BundleAssets(assets, this.assetsStorage);

    const bundle = new Bundle(name, manifest, bundleAssets);

    this._bundles.set(name, bundle);

    return bundle;
  }

  public get bundles() {
    return Object.fromEntries(this._bundles);
  }

  public bundle(name: string) {
    return this._bundles.get(name);
  }
}
